/// <amd-module name="Tfs/Widget/LinkPermissionsHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { UserClaims, userHasClaim } from "VSS/Platform/UserClaims";

/**
 * A helper class for making link readiness checks for widgets.
 * Some widgets may create links that point to unavailable pages for public or anonymous users.
 * Use permission checks here to gate the display of such links.
 */
export class LinkPermissionsHelper {
    private static isMemberUser(context: IVssPageContext): boolean {
        return userHasClaim(context, UserClaims.Member);
    }
    /**
     * Checks for user permission to access WIT queries.
     */
    public static canUserAccessWITQueriesPage(context: IVssPageContext): boolean {
        return LinkPermissionsHelper.isMemberUser(context);
    }
}
